import { Injectable } from '@angular/core';
import { IDashboardConfiguration } from 'src/app/modules/widget/interfaces/widget';
import { Parameter } from 'projects/common/src/app/classes';

@Injectable({
  providedIn: 'root'
})
export class DashboardParameterService extends Parameter<IDashboardConfiguration> {

  constructor() {
    super();
  }
}
